import { Dayjs } from "dayjs"
import { IWarrantsAccountWhitelist } from "@/models/admin/warrantsAccountWhitelist/warrantsAccountWhitelist.types"

export class WarrantsAccountWhitelist implements IWarrantsAccountWhitelist {
  constructor(
    public id: number,
    public accountNumber: string,
    public createdAt: Dayjs,
    public deletedAt: Dayjs | null,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }
}
